import { DataMessageTypeEnum } from '@terra/shared-dto-chat-types';
import { getToolConfig } from './tool-config';

export type BackgroundUpdateEntry = {
  agentType: string;
  stopped: boolean;
  toolCallId?: string;
};

export function readBackgroundUpdateAgentTypes(message: {
  parts?: readonly unknown[];
}): BackgroundUpdateEntry[] {
  const entries: BackgroundUpdateEntry[] = [];

  for (const part of message.parts ?? []) {
    if (!part || typeof part !== 'object') {
      continue;
    }

    const data = (part as { data?: unknown }).data;

    if (!data || typeof data !== 'object') {
      continue;
    }

    const record = data as {
      type?: unknown;
      agentType?: unknown;
      outcome?: unknown;
      toolCallId?: unknown;
    };

    if (record.type !== DataMessageTypeEnum.BackgroundUpdate) {
      continue;
    }

    if (typeof record.agentType === 'string' && record.agentType.length > 0) {
      entries.push({
        agentType: record.agentType,
        stopped: record.outcome === 'stopped',
        ...(typeof record.toolCallId === 'string'
          ? { toolCallId: record.toolCallId }
          : {}),
      });
    }
  }

  return entries;
}

export function finishedAgentDisplayName(agentType: string): string {
  if (agentType === 'neo') {
    return 'Neo';
  }

  const config = getToolConfig(agentType);

  return config.name === 'Action' ? agentType : config.name;
}
